<nida-web-user-detail
  #userDetail
  [currentUser]="currentUser"
  [personal]="personal"
  (cancelEdit)="cancelButtonPressed()"
  (save)="saveChanges()"
  (updatedUser)="userUpdated($event)"
></nida-web-user-detail>
